import { tokens } from "../tokens";

export const en = {
	[tokens.settings.addOns.digitalMenuUserLogin]: "Digital Menu User Login",
	[tokens.settings.addOns.digitalMenuUserSignUp]: "Digital Menu User Sign Up",
	[tokens.sidePanel.ops]: "Operations",
	[tokens.sidePanel.opsOffline]: "Operations (offline)",
	[tokens.sidePanel.inventories]: "Inventory management",
	[tokens.sidePanel.menus]: "Menu management",
	[tokens.sidePanel.receipts]: "Receipt management",
	[tokens.sidePanel.orders]: "Order management",
	[tokens.sidePanel.reports]: "Reports & analytics",
	[tokens.sidePanel.customers]: "Customer management",
	[tokens.sidePanel.offers]: "Offers management",
	[tokens.sidePanel.purchase]: "Purchase management",
	[tokens.sidePanel.settings]: "Settings",
	[tokens.sidePanel.openCashdrawer]: "Open cashdrawer",
	[tokens.searchBar.orderNumber]: "Order number",
	[tokens.searchBar.locationName]: "Location name",
	[tokens.searchBar.itemName]: "Item name",
	[tokens.searchBar.clearItemName]: "Clear item name search",
	[tokens.downloads.bill]: "Download Bill",
	[tokens.downloads.receipt]: "Download Receipt",
	[tokens.downloads.pdfFailed]: "Failed to generate PDF",
	[tokens.nav.till]: "Till",
	[tokens.nav.orders]: "Orders",
	[tokens.nav.locations]: "Locations",
	[tokens.nav.kds]: "KDS",
	[tokens.nav.reservations]: "Reservations",
	[tokens.ops.till.paidOrderItemAdditionDisabled]:
		"Adding item to a paid order is disabled.",
	[tokens.ops.prepStations.accept]: "Accept",
	[tokens.ops.prepStations.locations]: "Locations",
	[tokens.ops.prepStations.allLocations]: "All locations",
	[tokens.ops.prepStations.allPrinterTags]: "All printer tags",
	[tokens.ops.prepStations.enableSound]: "Enable sound",
	[tokens.ops.prepStations.hold]: "Hold",
	[tokens.ops.prepStations.held]: "Held",
	[tokens.ops.prepStations.holdTicket]: "Hold ticket",
	[tokens.ops.prepStations.kdsWorkflow]: "KDS workflow",
	[tokens.ops.prepStations.late]: "Late",
	[tokens.ops.prepStations.loadingKds]: "Loading KDS",
	[tokens.ops.prepStations.minutesShort]: "{{count}}m",
	[tokens.ops.prepStations.hoursMinutesShort]: "{{hours}}h {{minutes}}m",
	[tokens.ops.prepStations.daysHoursShort]: "{{days}}d {{hours}}h",
	[tokens.ops.prepStations.noLocation]: "No location",
	[tokens.ops.prepStations.noTickets]: "No {{workflow}} tickets.",
	[tokens.ops.prepStations.orderNumber]: "Order #{{order}}",
	[tokens.ops.prepStations.printerTags]: "Printer tags",
	[tokens.ops.prepStations.refreshError]:
		"Unable to refresh KDS. Please retry or reload.",
	[tokens.ops.prepStations.resume]: "Resume",
	[tokens.ops.prepStations.resumeTicket]: "Resume ticket",
	[tokens.ops.prepStations.sendTicket]: "Send ticket",
	[tokens.ops.prepStations.served]: "Served",
	[tokens.ops.prepStations.ticketAndOrder]:
		"Ticket #{{ticket}} · Order #{{order}}",
	[tokens.ops.prepStations.timerWithState]: "{{state}} · {{time}}",
	[tokens.ops.orders.placed]: "Placed",
	[tokens.ops.orders.preparing]: "Preparing",
	[tokens.ops.orders.processed]: "Processed",
	[tokens.ops.orders.unpaid]: "Unpaid",
	[tokens.ops.orders.paid]: "Paid",
	[tokens.ops.orders.d]: "d",
	[tokens.ops.orders.h]: "h",
	[tokens.ops.orders.items]: "Items",
	[tokens.ops.orders.cancelledItems]: "Cancelled items",
	[tokens.ops.orders.of]: "of",
	[tokens.ops.orders.prepared]: "prepared",
	[tokens.ops.orders.orderCreated]: "Order created",
	[tokens.ops.orders.movedToPreparing]: "Moved to preparing",
	[tokens.ops.orders.customerAcceptPrepTime]:
		"Customer accepted prep time updates",
	[tokens.ops.orders.customerRejectPrepTime]:
		"Customer rejected prep time updates",
	[tokens.ops.orders.prepTimeUpdate]: "Prep time was updated",
	[tokens.ops.orders.autoCancelledAllItems]:
		"Order automatically cancelled since all items were cancelled",
	[tokens.ops.orders.autoCancelledAllSplitItems]:
		"Order automatically cancelled as a result of all items being splitted",
	[tokens.ops.orders.autoCancelledAllMovedItems]:
		"Order automatically cancelled as a result of all items being moved to new location",
	[tokens.ops.orders.quantityChangeFrom]: "quantity changed from",
	[tokens.ops.orders.quantityChangeTo]: "to",
	[tokens.ops.orders.cancelled]: "cancelled",
	[tokens.ops.orders.discountChangeFrom]: "Order discount changed from",
	[tokens.ops.orders.discountChangeTo]: "to",
	[tokens.ops.orders.splitOf]: "of",
	[tokens.ops.orders.splitAll]: "All",
	[tokens.ops.orders.splited]: "were splitted",
	[tokens.ops.orders.moveOf]: "of",
	[tokens.ops.orders.moveAll]: "All",
	[tokens.ops.orders.moved]: "were moved to new location",
	[tokens.ops.orders.movedToProcessed]: "Move to processed",
	[tokens.ops.orders.markedAsPaid]: "Marked as paid by",
	[tokens.ops.orders.orderCancelled]: "Order cancelled",
	[tokens.ops.orders.auditOffer]: "Offer",
	[tokens.ops.orders.auditDiscount]: "Discount",
	[tokens.ops.orders.auditVat]: "VAT",
	[tokens.ops.orders.auditServiceChargeAd]: "Service charge (AD)",
	[tokens.ops.orders.auditServiceChargeBd]: "Service charge (BD)",
	[tokens.ops.orders.auditTax]: "Tax",
	[tokens.ops.orders.auditCardSurcharge]: "Card surcharge",
	[tokens.ops.orders.auditApplied]: "applied",
	[tokens.ops.orders.auditChanged]: "changed",
	[tokens.ops.orders.auditRemoved]: "removed",
	[tokens.ops.orders.auditWalletPayment]: "Wallet payment",
	[tokens.ops.orders.auditCustomer]: "Customer",
	[tokens.ops.orders.auditAdded]: "added",
	[tokens.ops.orders.auditMoved]: "moved",
	[tokens.ops.orders.auditFrom]: "from",
	[tokens.ops.orders.auditTo]: "to",
	[tokens.ops.orders.auditToOrder]: "to order",
	[tokens.ops.orders.auditItems]: "items",
	[tokens.ops.orders.auditOrderUpdated]: "Order updated",
	[tokens.ops.orders.auditOrder]: "Order",
	[tokens.ops.orders.auditUnknown]: "Unknown",
	[tokens.ops.orders.auditShowLess]: "Show less",
	[tokens.ops.orders.auditShowMore]: "+{{count}} more",
	[tokens.ops.orders.add]: "Add",
	[tokens.ops.orders.edit]: "Edit",
	[tokens.ops.orders.takePayment]: "Take payment",
	[tokens.ops.orders.processOrder]: "Process order",
	[tokens.ops.orders.prepareOrder]: "Prepare order",
	[tokens.ops.orders.printKitchenMessage]: "Print kitchen message",
	[tokens.ops.orders.printBill]: "Print bill",
	[tokens.ops.orders.printTicket]: "Print tickets",
	[tokens.ops.orders.printChecklist]: "Print checklists",
	[tokens.ops.orders.printCancelledTicket]: "Print cancelled ticket",
	[tokens.ops.orders.kitchenMessageContent]: "Kitchen message content",
	[tokens.ops.orders.messageIsRequired]: "Message is required",
	[tokens.ops.orders.headcountRequired]: "Headcount required",
	[tokens.ops.orders.cancelOrder]: "Cancel order",
	[tokens.ops.orders.cancelOrderModel]: "Cancel order?",
	[tokens.ops.orders.cancelOrderModelDesc]:
		"When an order is cancelled, you cannot change it status again, unless the a new order is created. Add a reason for the cancellation below",
	[tokens.ops.orders.subtotal]: "Subtotal:",
	[tokens.ops.orders.offer]: "Offer:",
	[tokens.ops.orders.discount]: "Discount:",
	[tokens.ops.orders.vat]: "VAT:",
	[tokens.ops.orders.service]: "Service:",
	[tokens.ops.orders.serviceAd]: "Service (AD):",
	[tokens.ops.orders.serviceBd]: "Service (BD):",
	[tokens.ops.orders.adjustment]: "Adjustment:",
	[tokens.ops.orders.grandTotal]: "Grand total:",
	[tokens.ops.orders.locationName]: "Location name",
	[tokens.ops.locations.showAllLocation]: "Showing all locations",
	[tokens.ops.locations.only]: "Only",
	[tokens.ops.locations.showing]: "Showing",
	[tokens.ops.locations.locations]: "Locations",
	[tokens.ops.locations.switchToListView]: "Switch to list view",
	[tokens.ops.locations.switchToFloorPlan]: "Switch to floorplan view",
	[tokens.ops.locations.createNewLocation]: "Create new location",
	[tokens.ops.locations.editLayout]: "Edit layout",
	[tokens.ops.locations.locationAvailable]: "This location is available",
	[tokens.ops.locations.addItem]: "Add items",
	[tokens.ops.locations.markedOccupied]: "Mark as occupied",
	[tokens.ops.locations.markedAvailable]: "Mark available",
	[tokens.ops.locations.defaultOrderNote]: "Location comment",
	[tokens.ops.locations.editThisLocation]: "Edit this location",
	[tokens.ops.locations.openConsumerApp]: "Open in consumer app",
	[tokens.ops.locations.getOrderQR]: "Get ordering QR",
	[tokens.ops.locations.deleteThisLocation]: "Delete this location",
	[tokens.ops.locations.totalVat]: "Total vat",
	[tokens.ops.locations.totalService]: "Total service",
	[tokens.ops.locations.totalServiceAd]: "Total service (AD)",
	[tokens.ops.locations.totalServiceBd]: "Total service (BD)",
	[tokens.ops.locations.totalBill]: "Total bill",
	[tokens.ops.locations.totalPaid]: "Total paid",
	[tokens.ops.locations.totalTax]: "Total tax",
	[tokens.ops.locations.totalUnpaid]: "Total unpaid",
	[tokens.ops.locations.moveOrdersAndItems]: "Move orders & items",
	[tokens.ops.locations.moveOrdersAndItemsTitle]:
		"Move orders and items out of",
	[tokens.ops.locations.selectAll]: "Select all",
	[tokens.ops.locations.printChecklist]: "Print checklist",
	[tokens.ops.locations.split]: "Split",
	[tokens.ops.locations.kitchenMessage]: "Kitchen message",
	[tokens.ops.locations.sendKitchenMessage]: "Send kitchen message",
	[tokens.ops.locations.addObjectToLayout]: "Add object to layout",
	[tokens.ops.locations.doneEditLayout]: "Done editing layout",
	[tokens.ops.locations.printBill]: "Print bill",
	[tokens.ops.locations.selectNewLocation]: "Select a new location",
	[tokens.ops.locations.categoryDisableMessage]:
		"Selected categories will be hidden from digital menu, but will remain visible in POS",
	[tokens.ops.locations.itemTypeDisableMessage]:
		"Selected item types will be hidden from digital menu, but will remain visible in POS",
	[tokens.ops.locations.itemDisableMessage]:
		"Selected items will be hidden from digital menu, but will remain visible in POS",
	[tokens.ops.locations.payNowMustBeAllowedMessage]:
		"Pay Now must be allowed to select payment types",
	[tokens.ops.locations.allowPayNow]: "Allow pay now for this location?",
	[tokens.ops.locations.allowPayLater]: "Allow pay later for this location?",
	[tokens.ops.locations.newLocationIdRequired]:
		"new locationID is a required field",
	[tokens.ops.locations.allOrders]: "All orders",
	[tokens.ops.locations.howDoYouWantToSplitThisTab]:
		"How do you want to split this tab?",
	[tokens.ops.locations.equally]: "Equally",
	[tokens.ops.locations.amoungHowManyPeopleWillThisTabBeSplitted]:
		"Among how many people will this tab be splitted",
	[tokens.ops.locations.eachPersonPays]: "Each person pays",
	[tokens.ops.locations.byItems]: "By items",
	[tokens.ops.locations.selectItemsTosplitIntoNewOrders]:
		"Select items to split into new order",
	[tokens.ops.locations.order]: "Order",
	[tokens.ops.locations.unpaid]: "Unpaid",
	[tokens.ops.locations.splitIntoNewOrder]: "Split into new order",
	[tokens.ops.locations.shape]: "Shape",
	[tokens.ops.locations.size]: "Size",
	[tokens.ops.locations.round]: "Round",
	[tokens.ops.locations.square]: "Square",
	[tokens.ops.locations.rectH]: "Rect H",
	[tokens.ops.locations.rectV]: "Rect V",
	[tokens.ops.locations.moveObject]: "Move Object",
	[tokens.ops.locations.deleteShape]: "Delete Object",
	[tokens.ops.locations.customObject]: "Custom object",
	[tokens.ops.locations.releaseToStop]:
		"Release to stop dragging, then finish when the position looks right.",
	[tokens.ops.locations.dragToPreview]:
		"Drag the selected object to preview its new position, then finish to save.",
	[tokens.ops.locations.finish]: "Finish",
	[tokens.ops.locations.notOnFloorYet]: "Not on floor plan yet",
	[tokens.ops.locations.floorObjects]: "Floor Objects",
	[tokens.ops.locations.wallH]: "Wall H",
	[tokens.ops.locations.wallV]: "Wall V",
	[tokens.ops.locations.poolTable]: "Pool table",
	[tokens.ops.locations.pool]: "Pool",
	[tokens.ops.locations.barH]: "Bar H",
	[tokens.ops.locations.barV]: "Bar V",
	[tokens.ops.tills.createItem]: "Create item",
	[tokens.ops.tills.itemType]: "Item types",
	[tokens.ops.tills.paymentMode]: "Payment mode",
	[tokens.ops.tills.changeToTab]: "Charge to tab",
	[tokens.ops.tills.payNow]: "Pay now",
	[tokens.ops.tills.paid]: "Paid",
	[tokens.ops.tills.clear]: "Clear",
	[tokens.ops.tills.options]: "Options",
	[tokens.ops.tills.listedPrice]: "Listed price (per unit)",
	[tokens.ops.tills.itemComments]: "Item comments",
	[tokens.ops.tills.cancel]: "Cancel",
	[tokens.ops.tills.save]: "Save",
	[tokens.ops.tills.customer]: "Customer",
	[tokens.ops.tills.kitchenMessage]: "Send",
	[tokens.ops.tills.lowestDenominator]: "Lowest denominator",
	[tokens.ops.tills.addHeadCount]: "Add headcount",
	[tokens.ops.tills.headCount]: "Headcount",
	[tokens.ops.tills.selectPaymentType]: "Select payment type",
	[tokens.ops.tills.addTips]: "Add tips",
	[tokens.ops.tills.paymentTypeUsed]: "Payment type used",
	[tokens.ops.tills.changeCalculator]: "Change calculator",
	[tokens.ops.tills.totalRecieved]: "Total received",
	[tokens.ops.tills.totalCashPayment]: "Total cash payment",
	[tokens.ops.tills.change]: "Change",
	[tokens.ops.tills.remainingAmount]: "Remaining amount",
	[tokens.ops.tills.balanceDue]: "Balance due",
	[tokens.ops.tills.locationIsRequired]: "Location is required",
	[tokens.ops.tills.optionGroups]: "Option groups",
	[tokens.ops.tills.minimumSelect]: "Minimum select",
	[tokens.ops.tills.maximumSelect]: "Maximum select",
	[tokens.ops.tills.noLimit]: "No limit",
	[tokens.ops.tills.required]: "Required",
	[tokens.ops.tills.nonRequired]: "Non-Required",
	[tokens.ops.tills.grandTotal]: "Grand total",
	[tokens.ops.tills.courseSeperator]: "Course separator",
	[tokens.ops.tills.showMore]: "Show more",
	[tokens.ops.tills.showLess]: "Show less",
	[tokens.ops.tills.cancelledThisItem]: "Cancel this item?",
	[tokens.ops.tills.cancelledThisItemDesc]:
		"When an item is cancelled, you cannot uncancel it. But you can edit or add this item again to this order from till. Add a reson for the cancellation below",
	[tokens.ops.tills.currentQty]: "Current qty",
	[tokens.ops.tills.cancelQty]: "Cancel qty",
	[tokens.ops.tills.cancelQtyRange]:
		"Cancel qty must be between 1 and {{quantity}}",
	[tokens.ops.tills.cancelQtyRequired]: "Cancel qty is required",
	[tokens.ops.tills.cancelQtyInteger]: "Cancel qty must be a whole number",
	[tokens.ops.tills.tips]: "Tips",
	[tokens.ops.tills.tipModelTitleBeforeAmount]:
		"Payment amount is greater than grand total",
	[tokens.ops.tills.tipModelTitleAfterAmount]: "amount will be added to tips",
	[tokens.ops.tills.headcountRequiredBeforeTakePayment]:
		"Require headcount before payment",
	[tokens.ops.tills.invalidPaymentAmount]: "Invalid payment amount",
	[tokens.ops.tills.selectTip]: "Select tips",
	[tokens.reports.nav.shift]: "Shift",
	[tokens.reports.nav.from]: "From",
	[tokens.reports.nav.to]: "To",
	[tokens.reports.nav.generate]: "Generate",
	[tokens.reports.nav.export]: "Export",
	[tokens.reports.nav.summary]: "Summary",
	[tokens.reports.nav.customs]: "Customs",
	[tokens.reports.nav.receipts]: "Receipts",
	[tokens.reports.nav.categories]: "Categories",
	[tokens.reports.nav.items]: "Items",
	[tokens.reports.nav.options]: "Options",
	[tokens.reports.nav.locations]: "Locations",
	[tokens.reports.nav.staffs]: "Staffs",
	[tokens.reports.nav.details]: "Details",
	[tokens.reports.nav.voids]: "Voids",
	[tokens.reports.nav.inventory]: "Inventory",
	[tokens.reports.nav.orders]: "Orders",
	[tokens.reports.nav.payments]: "Payments",
	[tokens.menus.menuManagement]: "Menu management",
	[tokens.menus.menus]: "Menus",
	[tokens.menus.createNewMenu]: "Create new menu",
	[tokens.menus.updateMenu]: "Update menu",
	[tokens.menus.logo]: "Logo",
	[tokens.menus.name]: "Name",
	[tokens.menus.description]: "Description",
	[tokens.menus.visible]: "Visible",
	[tokens.menus.view]: "View",
	[tokens.menus.edit]: "Edit",
	[tokens.menus.viewItems]: "View items",
	[tokens.menus.viewOptions]: "View options",
	[tokens.menus.copyExistingCategory]: "Copy existing category",
	[tokens.menus.copyThisCategory]: "Copy this category",
	[tokens.menus.createNewCategory]: "Create new category",
	[tokens.menus.copyFromExistingItem]: "Copy from existing item",
	[tokens.menus.copyThisItem]: "Copy this item",
	[tokens.menus.createNewItem]: "Create new item",
	[tokens.menus.selectACategoryFirstBeforeCloningItem]:
		"Select a category first before cloning item",
	[tokens.menus.categoryName]: "Category name",
	[tokens.menus.price]: "Price",
	[tokens.menus.type]: "Type",
	[tokens.menus.category]: "Category",
	[tokens.menus.pos]: "POS",
	[tokens.menus.digitalMenu]: "Digital menu",
	[tokens.menus.categoryTitle]: "Category title",
	[tokens.menus.categoryIsARequiredField]: "Category is a required field",
	[tokens.menus.titleIsARequiredField]: "Title is a required field",
	[tokens.menus.displayInDigitalMenu]: "Display in digital menu?",
	[tokens.menus.displayInTill]: "Display in till?",
	[tokens.menus.printer]: "Printer",
	[tokens.menus.printerTagIsARequiredField]: "Printer_tag is a required field",
	[tokens.menus.typeIsARequiredField]: "Type is a required field",
	[tokens.menus.title]: "Title",
	[tokens.menus.originalPrice]: "Original price",
	[tokens.menus.prepTime]: "Prep time",
	[tokens.menus.extraQuantity]: "Extra quantity",
	[tokens.menus.listedPrice]: "Listed price",
	[tokens.menus.addOption]: "Add option",
	[tokens.menus.copyOption]: "Copy option",
	[tokens.menus.copyThisOption]: "Copy this option",
	[tokens.menus.copyOptionToItem]: "Copy option to item",
	[tokens.menus.addOptionGroup]: "Add option group",
	[tokens.menus.copyOptionGroup]: "Copy option group",
	[tokens.menus.addOptionGroupToItem]: "Add option group to the item",
	[tokens.menus.copyOptionGroupToItem]: "Copy option group to the item",
	[tokens.menus.newOptionsGroup]: "New options group",
	[tokens.menus.copyThisOptionGroup]: "Copy this option group",
	[tokens.menus.copyFromExistingOptionGroup]: "Copy from existing option group",
	[tokens.menus.copyFromExistingOptions]: "Copy from existing options",
	[tokens.menus.optionGroupName]: "Option group name",
	[tokens.menus.updateOptionGroup]: "Update option group",
	[tokens.menus.addFromExistingOption]: "Add from existing option",
	[tokens.menus.removeThisOption]: "Remove this option",
	[tokens.menus.optionTitle]: "Option title",
	[tokens.menus.updateItem]: "Update item",
	[tokens.menus.itemOptions]: "Item options",
	[tokens.menus.itemOptionGroups]: "Item option groups",
	[tokens.menus.manageItemRecipe]: "Manage item recipe",
	[tokens.menus.selectOptions]: "Select options",
	[tokens.menus.selectOptionGroups]: "Select option groups",
	[tokens.menus.updateRecipeToMenuOption]: "Update recipe to menu option",
	[tokens.menus.updateItemOptionGroup]: "Update item option group",
	[tokens.menus.requiredOption]: "Required option",
	[tokens.menus.minimumSelect]: "Minimum select",
	[tokens.menus.maximumSelect]: "Maximum select",
	[tokens.menus.zeroMeansNoLimit]: "0 = no limit",
	[tokens.menus.addThisOption]: "Add this option",
	[tokens.menus.newOption]: "New option",
	[tokens.menus.createNewOptionGroup]: "Create new option group",
	[tokens.menus.createNewOption]: "Create new option",
	[tokens.menus.updateOption]: "Update option",
	[tokens.menus.optionGroupTitle]: "Option group title",
	[tokens.menus.optionName]: "Name",
	[tokens.menus.optionPrice]: "Price",
	[tokens.menus.duplicateOptionName]: "Duplicate option name",
	[tokens.menus.duplicateOptionGroupName]: "Duplicate option group name",
	[tokens.menus.youAreAboutToDeleteThisOption]:
		"You are about to delete this option",
	[tokens.menus.vat]: "VAT",
	[tokens.menus.serviceCharge]: "Service charge",
	[tokens.menus.serviceChargeBd]: "Service charge (BD)",
	[tokens.menus.openItem]: "Open item",
	[tokens.menus.autoSelectOption]: "Auto-Select",
	[tokens.menus.minimumRequiredPrice]: "Minimum required price",
	[tokens.menus.itemId]: "Item id",
	[tokens.menus.optionId]: "Option id",
	[tokens.menus.itemCost]: "Item cost",
	[tokens.menus.optionCost]: "Option cost",
	[tokens.menus.isMaster]: "Is master",
	[tokens.menus.masterItems]: "Master items",
	[tokens.menus.selectedItems]: "Selected items",
	[tokens.menus.availableItems]: "Available items",
	[tokens.reports.summary.tableView]: "Table view",
	[tokens.reports.summary.chartView]: "Chart view",
	[tokens.reports.summary.subtotalPrice]: "Subtotal price",
	[tokens.reports.summary.discount]: "Discount",
	[tokens.reports.summary.offers]: "Offers",
	[tokens.reports.summary.netSales]: "Net sales",
	[tokens.reports.summary.serviceCharge]: "Service charge (AD)",
	[tokens.reports.summary.serviceChargeBd]: "Service charge (BD)",
	[tokens.reports.summary.vat]: "VAT",
	[tokens.reports.summary.grossSales]: "Gross sales",
	[tokens.reports.summary.adjustment]: "Adjustment",
	[tokens.reports.summary.cancelled]: "Cancelled",
	[tokens.reports.summary.roundingAmount]: "Rounding amount",
	[tokens.reports.summary.paymentsReceived]: "Payments received",
	[tokens.reports.summary.salesByDays]: "Sales by days",
	[tokens.reports.summary.columns]: "Columns", //1
	[tokens.reports.summary.filters]: "Filters",
	[tokens.reports.summary.density]: "Density",
	[tokens.reports.summary.findColumn]: "Find column",
	[tokens.reports.summary.columnTitle]: "Column title",
	[tokens.reports.summary.hideAll]: "Hide all",
	[tokens.reports.summary.showAll]: "Show all",
	[tokens.reports.summary.operator]: "Operator",
	[tokens.reports.summary.value]: "Value",
	[tokens.reports.summary.is]: "Is",
	[tokens.reports.summary.isNot]: "Is not",
	[tokens.reports.summary.isAfter]: "Is after",
	[tokens.reports.summary.isOnOrAfter]: "Is on or after",
	[tokens.reports.summary.isBefore]: "Is before",
	[tokens.reports.summary.isOnOrBefore]: "Is on or before",
	[tokens.reports.summary.clear]: "Clear",
	[tokens.reports.summary.today]: "Today",
	[tokens.reports.summary.equals]: "Equals",
	[tokens.reports.summary.notEqual]: "Not equal",
	[tokens.reports.summary.greaterThan]: "Greater than",
	[tokens.reports.summary.greaterThanOrEqual]: "Greater than or equal",
	[tokens.reports.summary.lessThan]: "Less than",
	[tokens.reports.summary.lessThanOrEqual]: "Less than or equal",
	[tokens.reports.summary.isAnyOf]: "Is any of",
	[tokens.reports.summary.date]: "Date",
	[tokens.reports.summary.offerAmount]: "Offer amount",
	[tokens.reports.summary.discountAmount]: "Discount amount",
	[tokens.reports.summary.cancelledAmount]: "Cancelled amount",
	[tokens.reports.summary.avgOrderAmount]: "Avg order amount",
	[tokens.reports.summary.receiptsCount]: "Receipts count",
	[tokens.reports.summary.averageReceiptAmount]: "Average receipt amount",
	[tokens.reports.summary.compact]: "Compact",
	[tokens.reports.summary.standard]: "Standard",
	[tokens.reports.summary.comfortable]: "Comfortable",
	[tokens.reports.summary.downloadAsCsv]: "Download as csv",
	[tokens.reports.summary.print]: "Print", //1
	[tokens.reports.summary.beforeYouProceed]: "Before you proceed",
	[tokens.reports.summary.processTakesAwhileMessage]:
		"This process may take a while since we'll need to gather and calculate all your sdales data within the specified date range that you set. The longer the date range you set, the longer the process will take",
	[tokens.reports.summary.printerForReportIsAvailable]:
		'Printer for "report" is available',
	[tokens.reports.summary.printerForReportIsNotAvailable]:
		"No `report` printer is available",
	[tokens.reports.summary.printServiceIsOnlineMessage]:
		"Print service is online. Keep it online till the reports is printed",
	[tokens.reports.summary.printServiceIsOfflineMessage]:
		"Print service is offline. Please start your print service",
	[tokens.reports.summary.setupHere]: "",
	[tokens.reports.summary.selectTheTypeOfReportsForExport]:
		"Select the type of reports you want to export:",
	[tokens.reports.summary.salesSummaryReports]: "Sales summary reports",
	[tokens.reports.summary.itemsSalesReports]: "Items sales reports",
	[tokens.reports.summary.printOnlyItemsWithSales]:
		"Print only items with sales?",
	[tokens.reports.summary.paymentTypes]: "Payment types",
	[tokens.reports.summary.locationGroupTags]: "Location group tags",
	[tokens.reports.summary.locations]: "Locations",
	[tokens.reports.summary.downloadSoftCopy]: "Download soft copy",
	[tokens.reports.custom.newCustomReportCard]: "New custom report card",
	[tokens.reports.custom.updateCustomReportCard]: "Update custom report card",
	[tokens.reports.custom.cardHeader]: "Card header",
	[tokens.reports.custom.chartType]: "Chart type",
	[tokens.reports.custom.configuration]: "Configuration",
	[tokens.reports.custom.label]: "Label",
	[tokens.reports.custom.salesValue]: "Sales value",
	[tokens.reports.custom.dataType]: "Data type",
	[tokens.reports.custom.dataPoint]: "Data point",
	[tokens.reports.custom.addDataPoint]: "Add data point",
	[tokens.reports.custom.bulkAddDataPoint]: "Bulk add data points",
	[tokens.reports.custom.youAreAboutToDeleteThisCustomReport]:
		"You are about to delete this custom report",
	[tokens.reports.custom.id]: "ID",
	[tokens.reports.custom.title]: "Title",
	[tokens.reports.custom.unitPrice]: "Unit price",
	[tokens.reports.custom.count]: "Count",
	[tokens.reports.custom.subtotal]: "Subtotal",
	[tokens.reports.custom.discount]: "Discount",
	[tokens.reports.custom.offer]: "Offer",
	[tokens.reports.custom.netSales]: "Net sales",
	[tokens.reports.custom.serviceCharge]: "Service charge (AD)",
	[tokens.reports.custom.serviceChargeBd]: "Service charge (BD)",
	[tokens.reports.custom.vat]: "VAT",
	[tokens.reports.custom.grossSales]: "Gross sales",
	[tokens.reports.custom.cancelledValue]: "Cancelled value",
	[tokens.reports.receipts.avgPaymentPerReceipt]: "Avg payment per receipt",
	[tokens.reports.receipts.receiptCount]: "Receipt count",
	[tokens.reports.receipts.nonVoidReceipt]: "Non-Void receipt",
	[tokens.reports.receipts.voidReceipt]: "Void receipt",
	[tokens.reports.receipts.byReceiptTypes]: "By receipt types",
	[tokens.reports.receipts.internalReceipts]: "Internal receipts",
	[tokens.reports.receipts.externalReceipts]: "External receipts",
	[tokens.reports.receipts.allBlank]: "All blank",
	[tokens.reports.receipts.addFilter]: "Add filter",
	[tokens.reports.receipts.year]: "Year",
	[tokens.reports.receipts.month]: "Month",
	[tokens.reports.receipts.date]: "Date",
	[tokens.reports.receipts.hour]: "Hour",
	[tokens.reports.receipts.minute]: "Minute",
	[tokens.reports.receipts.receipt]: "Receipt #",
	[tokens.reports.receipts.orders]: "Orders #",
	[tokens.reports.receipts.locationTypes]: "Location types",
	[tokens.reports.receipts.locationName]: "Location name",
	[tokens.reports.receipts.paidBy]: "Paid By",
	[tokens.reports.receipts.staff]: "Staff",
	[tokens.reports.receipts.status]: "Status",
	[tokens.reports.receipts.subtotalPrice]: "Subtotal price",
	[tokens.reports.receipts.offerName]: "Offer name",
	[tokens.reports.receipts.offerAmount]: "Offer amount",
	[tokens.reports.receipts.discountAmount]: "Discount amount",
	[tokens.reports.receipts.netSales]: "Net sales",
	[tokens.reports.receipts.vat]: "VAT",
	[tokens.reports.receipts.serviceCharge]: "Service charge (AD)",
	[tokens.reports.receipts.serviceChargeBd]: "Service charge (BD)",
	[tokens.reports.receipts.grossAmount]: "Gross amount",
	[tokens.reports.receipts.roundingAmt]: "Rounding Amt",
	[tokens.reports.receipts.adjustmentAmt]: "Adjustment Amt",
	[tokens.reports.receipts.cancelledAmount]: "Cancelled amount",
	[tokens.reports.receipts.paymentTypes]: "Payment types",
	[tokens.reports.receipts.paymentsReceived]: "Payments received",
	[tokens.reports.receipts.customers]: "Customers",
	[tokens.reports.receipts.headcount]: "Headcount",
	[tokens.reports.receipts.tips]: "Tips",
	[tokens.reports.receipts.shift]: "Shift",
	[tokens.reports.receipts.paywayrefs]: "PayWayRef(s)",
	[tokens.reports.receipts.kpayPaymentTypes]: "KPay payment types",
	[tokens.reports.categories.total]: "Total",
	[tokens.reports.categories.top10ByRevenue]: "Top 10 by revenue",
	[tokens.reports.categories.top10BySoldItems]: "Top 10 by sold items",
	[tokens.reports.categories.categoryName]: "Category name",
	[tokens.reports.categories.soldItems]: "Sold items",
	[tokens.reports.categories.revenue]: "Revenue",
	[tokens.reports.categories.title]: "Title",
	[tokens.reports.categories.subtotal]: "Subtotal",
	[tokens.reports.categories.discount]: "Discount",
	[tokens.reports.categories.offer]: "Offer",
	[tokens.reports.categories.netSales]: "Net sales",
	[tokens.reports.categories.serviceCharge]: "Service charge (AD)",
	[tokens.reports.categories.serviceChargeBd]: "Service charge (BD)",
	[tokens.reports.categories.vat]: "VAT",
	[tokens.reports.categories.grossSales]: "Gross sales",
	[tokens.reports.categories.cancelledValue]: "Cancelled value",
	[tokens.reports.categories.sort]: "Sort",
	[tokens.reports.categories.unsort]: "Unsort",
	[tokens.reports.categories.sortByAsc]: "Sort by Asc",
	[tokens.reports.categories.sortByDesc]: "Sort by Desc",
	[tokens.reports.categories.filters]: "Filters",
	[tokens.reports.categories.hideAll]: "Hide all",
	[tokens.reports.categories.showColumns]: "Show columns",
	[tokens.reports.categories.pinToLeft]: "Pin to left",
	[tokens.reports.categories.pinToRight]: "Pin to right",
	[tokens.reports.items.revenueByItemTypes]: "Revenue by item types",
	[tokens.reports.items.soldItemsByItemTypes]: "Sold items by item types",
	[tokens.reports.items.itemType]: "Item type",
	[tokens.reports.items.revenue]: "Revenue",
	[tokens.reports.items.itemTitle]: "Item title",
	[tokens.reports.items.optionTitle]: "Option title",
	[tokens.reports.items.categoryTitle]: "Category title",
	[tokens.reports.items.subtotal]: "Subtotal",
	[tokens.reports.items.netAmount]: "Net amount",
	[tokens.reports.items.total]: "Total",
	[tokens.reports.items.soldItem]: "Sold item",
	[tokens.reports.items.discount]: "Discount",
	[tokens.reports.items.offer]: "Offer",
	[tokens.reports.items.serviceCharge]: "Service charge (AD)",
	[tokens.reports.items.serviceChargeBd]: "Service charge (BD)",
	[tokens.reports.items.vat]: "VAT",
	[tokens.reports.items.grossSales]: "Gross sales",
	[tokens.reports.items.cost]: "Cost",
	[tokens.reports.items.profitMarginAmt]: "Profit margin $",
	[tokens.reports.items.profitMarginPerc]: "Profit margin %",
	[tokens.reports.items.cancelledValue]: "Cancelled value",
	[tokens.reports.items.itemId]: "Item id",
	[tokens.reports.items.top10ByRevenue]: "Top 10 by revenue",
	[tokens.reports.items.top10BySoldItems]: "Top 10 by sold items",
	[tokens.reports.options.revenue]: "Revenue",
	[tokens.reports.options.optionTitle]: "Option title",
	[tokens.reports.options.optionTitle]: "Option title",
	[tokens.reports.options.categoryTitle]: "Category title",
	[tokens.reports.options.subtotal]: "Subtotal",
	[tokens.reports.options.netAmount]: "Net amount",
	[tokens.reports.options.total]: "Total",
	[tokens.reports.options.soldOption]: "Sold option",
	[tokens.reports.options.discount]: "Discount",
	[tokens.reports.options.offer]: "Offer",
	[tokens.reports.options.serviceCharge]: "Service charge (AD)",
	[tokens.reports.options.serviceChargeBd]: "Service charge (BD)",
	[tokens.reports.options.vat]: "VAT",
	[tokens.reports.options.grossSales]: "Gross sales",
	[tokens.reports.options.cost]: "Cost",
	[tokens.reports.options.profitMarginAmt]: "Profit margin $",
	[tokens.reports.options.profitMarginPerc]: "Profit margin %",
	[tokens.reports.options.cancelledValue]: "Cancelled value",
	[tokens.reports.options.optionId]: "Option id",
	[tokens.reports.options.top10ByRevenue]: "Top 10 by revenue",
	[tokens.reports.options.top10BySoldItems]: "Top 10 by sold items",
	[tokens.menus.hideFromReceipt]: "Hide in receipt",
	[tokens.menus.isHideFromReceipt]: "Hide in receipt",
	[tokens.menus.action]: "Action",
	[tokens.reports.locations.mostPopular]: "Most popular",
	[tokens.reports.locations.topMoneyMaker]: "Top money maker",
	[tokens.reports.locations.receivedPaymentsAll]: "Received payments (all)",
	[tokens.reports.locations.salesByLocationGroupAll]:
		"Sales by Location Group (All)",
	[tokens.reports.locations.locationTypes]: "Location types",
	[tokens.reports.locations.paymentTypes]: "Payment types",
	[tokens.reports.locations.showingAllLocations]: "Showing all locations",
	[tokens.reports.locations.onlyXLocations]: 'Only "x" Locations',
	[tokens.reports.locations.locationNames]: "Location names",
	[tokens.reports.locations.ordersCount]: "Orders count",
	[tokens.reports.locations.receiptCount]: "Receipt count",
	[tokens.reports.locations.headcount]: "Headcount",
	[tokens.reports.locations.receiptsAmount]: "Receipts amount",
	[tokens.reports.locations.subtotalPrice]: "Subtotal price",
	[tokens.reports.locations.offerAmount]: "Offer amount",
	[tokens.reports.locations.discountAmount]: "Discount amount",
	[tokens.reports.locations.netSales]: "Net sales",
	[tokens.reports.locations.vatAmount]: "VAT amount",
	[tokens.reports.locations.serviceChargeAmount]: "Service charge (AD) amount",
	[tokens.reports.locations.serviceChargeBdAmount]:
		"Service Charge (BD) Amount",
	[tokens.reports.locations.grossAmount]: "Gross amount",
	[tokens.reports.locations.roundingAmt]: "Rounding Amt",
	[tokens.reports.locations.adjustmentAmount]: "Adjustment amount",
	[tokens.reports.locations.cancelledAmount]: "Cancelled amount",
	[tokens.reports.locations.byPaymentTypes]: "By payment types",
	[tokens.reports.staffs.topPerformerByOrdersCount]:
		"Top Performer By Orders Count",
	[tokens.reports.staffs.ordersCount]: "Orders count",
	[tokens.reports.staffs.ordersGrossSales]: "Orders gross sales",
	[tokens.reports.staffs.topPerformerByOrdersGrossSales]:
		"Top Performer by Orders Gross Sales",
	[tokens.reports.staffs.staffName]: "Staff name",
	[tokens.reports.details.grossAmount]: "Gross amount",
	[tokens.reports.details.qr]: "QR",
	[tokens.reports.details.till]: "Till",
	[tokens.reports.details.averageOrderAmount]: "Average order amount",
	[tokens.reports.details.ordersCount]: "Orders count",
	[tokens.reports.details.year]: "Year",
	[tokens.reports.details.month]: "Month",
	[tokens.reports.details.date]: "Date",
	[tokens.reports.details.hour]: "Hour",
	[tokens.reports.details.minute]: "Minute",
	[tokens.reports.details.receipt]: "Receipt#",
	[tokens.reports.details.orders]: "Orders #",
	[tokens.reports.details.locationTypes]: "Location types",
	[tokens.reports.details.locationName]: "Location name",
	[tokens.reports.details.orderThrough]: "Order through",
	[tokens.reports.details.createdBy]: "Created By",
	[tokens.reports.details.paidBy]: "Paid By",
	[tokens.reports.details.staffName]: "Staff name",
	[tokens.reports.details.category]: "Category",
	[tokens.reports.details.itemType]: "Item type",
	[tokens.reports.details.item]: "Item",
	[tokens.reports.details.masterItemTitle]: "Master item name",
	[tokens.reports.details.status]: "Status",
	[tokens.reports.details.isPaid]: "Is paid",
	[tokens.reports.details.isCancelled]: "Is cancelled",
	[tokens.reports.details.qty]: "Qty",
	[tokens.reports.details.unitPrice]: "Unit price",
	[tokens.reports.details.subtotalPrice]: "Subtotal price",
	[tokens.reports.details.offerName]: "Offer name",
	[tokens.reports.details.offerAmount]: "Offer amount",
	[tokens.reports.details.discountAmount]: "Discount amount",
	[tokens.reports.details.netSales]: "Net sales",
	[tokens.reports.details.vatIncluded]: "VAT (*included)",
	[tokens.reports.details.scIncluded]: "Service charge (*included)",
	[tokens.reports.details.adjustmentAmount]: "Adjustment amount",
	[tokens.reports.details.cancelledAmount]: "Cancelled amount",
	[tokens.reports.details.cancelledReason]: "Cancelled reason",
	[tokens.reports.details.finalPaymentType]: "Final payment type",
	[tokens.reports.details.cost]: "Cost",
	[tokens.reports.details.profitMarginAmt]: "Profit margin $",
	[tokens.reports.details.profitMarginPerc]: "Profit margin %",
	[tokens.reports.details.customers]: "Customers",
	[tokens.reports.details.shift]: "Shift",
	[tokens.reports.details.paywayRef]: "PayWay ref",
	[tokens.reports.details.itemId]: "Item id",
	[tokens.reports.voids.voidedCount]: "Voided count",
	[tokens.reports.voids.voidedAmount]: "Voided amount",
	[tokens.reports.voids.year]: "Year",
	[tokens.reports.voids.month]: "Month",
	[tokens.reports.voids.date]: "Date",
	[tokens.reports.voids.hour]: "Hour",
	[tokens.reports.voids.minute]: "Minute",
	[tokens.reports.voids.cancelledItem]: "Cancelled item",
	[tokens.reports.voids.masterItemTitle]: "Master item name",
	[tokens.reports.voids.cancelledItemId]: "Cancelled item id",
	[tokens.reports.voids.itemCategory]: "Item category",
	[tokens.reports.voids.itemType]: "Item type",
	[tokens.reports.voids.user]: "User",
	[tokens.reports.voids.receipt]: "Receipt #",
	[tokens.reports.voids.orders]: "Order #",
	[tokens.reports.voids.locationTypes]: "Location types",
	[tokens.reports.voids.locationName]: "Location name",
	[tokens.reports.voids.orderThrough]: "Order through",
	[tokens.reports.voids.status]: "Status",
	[tokens.reports.voids.isPaid]: "Is paid",
	[tokens.reports.voids.qty]: "Qty",
	[tokens.reports.voids.unitPrice]: "Unit price",
	[tokens.reports.voids.voidAmount]: "Void amount",
	[tokens.reports.voids.voidReason]: "Void reason",
	[tokens.reports.voids.finalPaymentType]: "Final payment type",
	[tokens.reports.voids.walletPaymentType]: "Wallet payment type",
	[tokens.reports.voids.walletName]: "Wallet name",
	[tokens.reports.voids.customers]: "Customers",
	[tokens.reports.voids.shift]: "Shift",
	[tokens.reports.voids.digitalPaymentRef]: "Digital payment ref",
	[tokens.reports.inventory.liveData]: "Live data",
	[tokens.reports.inventory.historicalData]: "Historical data",
	[tokens.reports.inventory.totalInventoryBalanceValue]:
		"Total Inventory Balance Value",
	[tokens.reports.inventory.top10MostUtilisedRawMaterialsBalanceValue]:
		"Top 10 Most Utilised Raw Materials Balance Value",
	[tokens.reports.inventory.top10LeastUtilisedRawMaterialsBalanceValue]:
		"Top 10 Least Utilised Raw Materials Balance value",
	[tokens.reports.inventory.top10MostUtilised]: "Top 10 most utilised",
	[tokens.reports.inventory.top10LeastUtilised]: "Top 10 least utilised",
	[tokens.reports.inventory.name]: "Name",
	[tokens.reports.inventory.balanceQty]: "Balance qty",
	[tokens.reports.inventory.balanceValue]: "Balance value",
	[tokens.reports.inventory.rawMaterialName]: "Raw material name",
	[tokens.reports.inventory.rawMaterialCode]: "Raw material code",
	[tokens.reports.inventory.receivedUom]: "Received UoM",
	[tokens.reports.inventory.totalReceivedQty]: "Total received qty",
	[tokens.reports.inventory.totalConsumedQty]: "Total consumed qty",
	[tokens.reports.inventory.totalWastageQty]: "Total wastage qty",
	[tokens.reports.inventory.totalDefectQty]: "Total defect qty",
	[tokens.reports.inventory.totalExpiredQty]: "Total expired qty",
	[tokens.reports.inventory.totalAdjustmentQty]: "Total adjustment qty",
	[tokens.reports.inventory.balanceQuantity]: "Balance quantity",
	[tokens.reports.inventory.avgCostPerUom]: "Avg cost per UOM",
	[tokens.reports.inventory.balanceValue]: "Balance value $",
	[tokens.reports.inventory.supplierName]: "Supplier name",
	[tokens.reports.inventory.storageLocation]: "Storage location",
	[tokens.receipts.landing.dates]: "Dates",
	[tokens.receipts.landing.ordersUseForMultiples]:
		'Orders #, use "," for multiples',
	[tokens.receipts.landing.receiptsUseForMultiples]:
		'Receipts #, use "," for multiples',
	[tokens.receipts.landing.receipt]: "Receipt #",
	[tokens.receipts.landing.createdAt]: "Created at",
	[tokens.receipts.landing.location]: "Location",
	[tokens.receipts.landing.paymentType]: "Payment type",
	[tokens.receipts.landing.description]: "Description",
	[tokens.receipts.landing.actions]: "Actions",
	[tokens.receipts.landing.reprint]: "Reprint",
	[tokens.receipts.landing.voidReceipt]: "Void receipt",
	[tokens.receipts.landing.copyThisReceiptNumber]: "Copy this receipt number",
	[tokens.receipts.landing.copyThisPrintLogId]: "Copy this print log ID",
	[tokens.receipts.expandReceiptDetails.receipt]: "Receipt #",
	[tokens.receipts.expandReceiptDetails.ordersNumbers]: "Orders numbers",
	[tokens.receipts.expandReceiptDetails.OfPeople]: "# of People",
	[tokens.receipts.expandReceiptDetails.location]: "Location",
	[tokens.receipts.expandReceiptDetails.printedDate]: "Printed date",
	[tokens.receipts.expandReceiptDetails.orderedDate]: "Ordered date",
	[tokens.receipts.expandReceiptDetails.subtotal]: "Subtotal",
	[tokens.receipts.expandReceiptDetails.offer]: "Offer",
	[tokens.receipts.expandReceiptDetails.discount]: "Discount",
	[tokens.receipts.expandReceiptDetails.vat]: "VAT",
	[tokens.receipts.expandReceiptDetails.serviceCharge]: "Service charge",
	[tokens.receipts.expandReceiptDetails.serviceChargeAd]: "Service charge (AD)",
	[tokens.receipts.expandReceiptDetails.serviceChargeBd]: "Service charge (BD)",
	[tokens.receipts.expandReceiptDetails.adjustmentValue]: "Adjustment value",
	[tokens.receipts.expandReceiptDetails.grandTotal]: "Grand total",
	[tokens.receipts.expandReceiptDetails.roundingDifference]:
		"Rounding Difference",
	[tokens.receipts.expandReceiptDetails.paymentTypes]: "Payment types",
	[tokens.receipts.expandReceiptDetails.cashReceived]: "Cash received",
	[tokens.receipts.expandReceiptDetails.cashChanges]: "Cash changes",
	[tokens.receipts.expandReceiptDetails.cancelledAmount]: "Cancelled amount",
	[tokens.receipts.expandReceiptDetails.paymentNotEqualToGrandTotal]:
		"Payments amount is not equal to grand total",
	[tokens.receipts.expandReceiptDetails.cancelledItems]: "Cancelled items",
	[tokens.receipts.expandReceiptDetails.addPaymentType]: "Add payment type",
	[tokens.orders.landing.dates]: "Dates",
	[tokens.orders.landing.ordersUseForMultiples]:
		'Orders #, use "," for multiples',
	[tokens.orders.landing.createdAt]: "Created at",
	[tokens.orders.landing.paymentStatus]: "Payment status",
	[tokens.orders.landing.description]: "Description",
	[tokens.orders.landing.orderStatus]: "Order status",
	[tokens.orders.landing.copyThisOrderId]: "Copy this order ID",
	[tokens.orders.landing.placed]: "Placed",
	[tokens.orders.landing.preparing]: "Preparing",
	[tokens.orders.landing.processed]: "Processed",
	[tokens.customers.landing.searchPlaceholder]:
		"Search by name, phone number, or customer id",
	[tokens.customers.landing.newCustomer]: "New customer",
	[tokens.customers.landing.creatingNewCustomer]: "Creating new customer",
	[tokens.customers.landing.formMessage]:
		"Fill out below form to create new customer for your venue",
	[tokens.customers.landing.firstName]: "First name",
	[tokens.customers.landing.firstNameIsRequired]: "First name is required",
	[tokens.customers.landing.lastName]: "Last name",
	[tokens.customers.landing.lastNameIsRequired]: "Last name is required",
	[tokens.customers.landing.phoneNumber]: "Phone number",
	[tokens.customers.landing.uniqueId]: "Unique id",
	[tokens.customers.landing.socials]: "Socials linked to this phone number",
	[tokens.customers.landing.createdAt]: "Created at",
	[tokens.customers.landing.fullName]: "Full name",
	[tokens.customers.customerDetails.email]: "Email",
	[tokens.customers.customerDetails.nationality]: "Nationality",
	[tokens.customers.customerDetails.birthday]: "Birthday",
	[tokens.customers.customerDetails.unit]: "Unit",
	[tokens.customers.customerDetails.floor]: "Floor",
	[tokens.customers.customerDetails.building]: "Building",
	[tokens.customers.customerDetails.street]: "Street",
	[tokens.customers.customerDetails.area]: "Area",
	[tokens.customers.customerDetails.city]: "City",
	[tokens.customers.customerDetails.province]: "Province",
	[tokens.customers.customerDetails.country]: "Country",
	[tokens.customers.customerDetails.fullAddress]: "Full address",
	[tokens.customers.customerDetails.address]: "Address",
	[tokens.customers.customerDetails.invalidEmail]:
		"Enter a valid email address",
	[tokens.customers.customerDetails.invalidBirthday]:
		"Enter a valid birthday (YYYY-MM-DD)",
	[tokens.customers.customerDetails.updatedSuccessfully]:
		"Customer info updated successfully",
	[tokens.customers.customerDetails.receiptSales]: "Receipt Sales",
	[tokens.customers.customerDetails.receiptCount]: "Receipt Count",
	[tokens.customers.customerDetails.avgSpendPerReceipt]:
		"Avg Spend Per Receipt",
	[tokens.customers.customerDetails.top5]: "Top 5",
	[tokens.customers.customerDetails.customerInfo]: " customer info",
	[tokens.customers.customerDetails.orderHistory]: "Orders history",
	[tokens.customers.customerDetails.firstName]: "First name",
	[tokens.customers.customerDetails.lastName]: "Last name",
	[tokens.customers.customerDetails.phoneNumber]: "Phone number",
	[tokens.customers.customerDetails.uniqueId]: "Unique id",
	[tokens.customers.customerDetails.username]: "Username",
	[tokens.customers.customerDetails.password]: "Password",
	[tokens.customers.customerDetails.generatePassword]: "Generate password",
	[tokens.customers.customerDetails.passwordTooShort]:
		"Password must be at least {{count}} characters",
	[tokens.customers.customerDetails.resetUserPassword]: "Reset User Password",
	[tokens.customers.customerDetails.resetUserPasswordFor]:
		"Set a new password for {{username}}",
	[tokens.customers.customerDetails.passwordResetSuccessfully]:
		"Password reset successfully",
	[tokens.customers.customerDetails.dates]: "Dates",
	[tokens.customers.customerDetails.items]: "Items",
	[tokens.customers.customerDetails.socials]:
		"Socials linked to this phone number",
	[tokens.customers.customerDetails.save]: "Save",
	[tokens.customers.customerDetails.salesSummary]: "Sales summary",
	[tokens.customers.customerDetails.grossAmount]: "Gross amount",
	[tokens.customers.customerDetails.ordersCount]: "Orders count",
	[tokens.customers.customerDetails.discount]: "Discount",
	[tokens.customers.customerDetails.columns]: "Columns",
	[tokens.customers.customerDetails.title]: "Title",
	[tokens.customers.customerDetails.soldCount]: "Sold count",
	[tokens.customers.customerDetails.hideAll]: "Hide all",
	[tokens.customers.customerDetails.showAll]: "Show all",
	[tokens.customers.customerDetails.filters]: "Filters",
	[tokens.customers.customerDetails.operator]: "Operator",
	[tokens.customers.customerDetails.value]: "Value",
	[tokens.customers.customerDetails.contains]: "Contains",
	[tokens.customers.customerDetails.equals]: "Equals",
	[tokens.customers.customerDetails.startsWith]: "Starts with",
	[tokens.customers.customerDetails.endsWith]: "Ends with",
	[tokens.customers.customerDetails.isEmpty]: "Is empty",
	[tokens.customers.customerDetails.isNotEmpty]: "Is not empty",
	[tokens.customers.customerDetails.isAnyOf]: "Is any of",
	[tokens.customers.customerDetails.density]: "Density",
	[tokens.customers.customerDetails.compact]: "Compact",
	[tokens.customers.customerDetails.standard]: "Standard",
	[tokens.customers.customerDetails.comfortable]: "Comfortable",
	[tokens.customers.customerDetails.export]: "Export",
	[tokens.customers.customerDetails.downloadAsCsv]: "Download as CSV",
	[tokens.customers.customerDetails.print]: "Print",
	[tokens.customers.customerDetails.sortByAsc]: "Sort by ASC",
	[tokens.customers.customerDetails.sortByDesc]: "Sort by DESC",
	[tokens.customers.customerDetails.showColumns]: "Show columns",
	[tokens.customers.customerDetails.pinToLeft]: "Pin to left",
	[tokens.customers.customerDetails.pinToRight]: "Pin to right",
	[tokens.customers.customerDetails.noResultsFound]: "No results found",
	[tokens.customers.customerDetails.rowsPerPage]: "Rows per page",
	[tokens.customers.customerDetails.createdAt]: "Created at",
	[tokens.customers.customerDetails.paymentStatus]: "Payment status",
	[tokens.customers.customerDetails.description]: "Description",
	[tokens.customers.customerDetails.orderStatus]: "Order status",
	[tokens.offers.landing.title]: "Title",
	[tokens.offers.landing.newOffer]: "New offer",
	[tokens.offers.landing.createdAt]: "Created at",
	[tokens.offers.landing.summary]: "Summary",
	[tokens.offers.landing.creatingNewOffer]: "Creating new offer",
	[tokens.offers.landing.formMessage]:
		"Fill out below form to create new offer for your venue",
	[tokens.offers.landing.offerTitle]: "Offer title",
	[tokens.offers.landing.tileIsRequired]: "Tile is required",
	[tokens.offers.landing.applyHigherValue]: "Apply higher value",
	[tokens.offers.landing.applyHighestValueMessage]:
		"If an item is qualified for 2 or more criterias, apply the highest value criteria",
	[tokens.offers.landing.applyLowestValueMessage]:
		"If an item is qualified for 2 or more criterias, apply the lowest value criteria",
	[tokens.offers.landing.addConfig]: "Add config",
	[tokens.offers.landing.byReceipts]: "By receipts",
	[tokens.offers.landing.useWithOtherConfigTypes]:
		"You can't use this with other config types",
	[tokens.offers.landing.byItems]: "By items",
	[tokens.offers.landing.byCategories]: "By categories",
	[tokens.offers.landing.byItemTypes]: "By item types",
	[tokens.offers.landing.discountByReceipts]: "Discount by receipts",
	[tokens.offers.landing.discountByItems]: "Discount by items",
	[tokens.offers.landing.applicableItems]: "Applicable items",
	[tokens.offers.landing.discountByCategories]: "Discount by categories",
	[tokens.offers.landing.applicableCategories]: "Applicable categories",
	[tokens.offers.landing.discountValue]: "Discount value",
	[tokens.offers.landing.discountByItemTypes]: "Discount by item types",
	[tokens.offers.landing.applicableItemTypes]: "Applicable types",
	[tokens.offers.offerDetails.offerInfo]: "Offer info",
	[tokens.offers.offerDetails.offerName]: "Offer name",
	[tokens.offers.offerDetails.offerStatus]: "Offer status",
	[tokens.offers.offerDetails.active]: "Active",
	[tokens.offers.offerDetails.configSummary]: "Config summary",
	[tokens.offers.offerDetails.offerHigherValueUponCollision]:
		"Offer higher value upon collision",
	[tokens.offers.offerDetails.offerLowerValueUponCollision]:
		"Offer lower value upon collision",
	[tokens.offers.offerDetails.editThisOffer]: "Edit this offer",
	[tokens.offers.offerDetails.deactivate]: "Deactivate",
	[tokens.offers.offerDetails.offerUsageSummary]: "Offer usage summary",
	[tokens.offers.offerDetails.ordersCount]: "Orders count",
	[tokens.offers.offerDetails.usageAmount]: "USage amount",
	[tokens.offers.offerDetails.ordersHistory]: "Orders history",
	[tokens.offers.offerDetails.dates]: "Dates",
	[tokens.offers.offerDetails.createdAt]: "Created at",
	[tokens.offers.offerDetails.paymentStatus]: "Payment status",
	[tokens.offers.offerDetails.description]: "Description",
	[tokens.offers.offerDetails.orderStatus]: "Order status",
	[tokens.offers.offerDetails.criterias]: "Criterias",
	[tokens.offers.offerDetails.updatingOffer]: "Updating offer",
	[tokens.offers.offerDetails.formHeaderDesc]:
		"Fill out below form to create new offer for your venue",
	[tokens.offers.offerDetails.youCanTUseThisWithOtherConfigTypes]:
		"You can't use this with other config types",
	[tokens.reports.summary.salesSummary]: "Sales summary",
	[tokens.settings.nav.general]: "General",
	[tokens.settings.nav.ordering]: "Ordering",
	[tokens.settings.nav.printing]: "Printing",
	[tokens.settings.nav.customs]: "Customs",
	[tokens.settings.nav.userPermissions]: "User permissions",
	[tokens.settings.nav.addOns]: "Add ons",
	[tokens.settings.general.name]: "Name",
	[tokens.settings.general.description]: "Description",
	[tokens.settings.general.address]: "Address",
	[tokens.settings.general.vatTin]: "VAT TIN",
	[tokens.settings.ordering.requireCustomerForDigitalMenuOrders]:
		"Require Customer for Digital Menu Orders",
	[tokens.settings.ordering.enableOrderCommentsForDigitalMenuOrders]:
		"Enable Order Comments for digital menu orders",
	[tokens.settings.ordering.digitalMenuLabel]:
		"Enable order confirmation before payment for digital menu",
	[tokens.settings.ordering.activateDoubleScreen]: "Activate double screen",
	[tokens.settings.ordering.noteLabel]: "Require note for digital menu orders",
	[tokens.settings.ordering.noteInstructionLabel]:
		"What should be note input instruction?",
	[tokens.settings.ordering.inputTheNoteInstructions]:
		"Input the note instructions",
	[tokens.settings.ordering.orderNotificationDings]:
		"Activate alarm for digital menu orders",
	[tokens.settings.ordering.orderNotificationDingsHelper]:
		"Input the amount of alarm rings (per interval)",
	[tokens.settings.ordering.requireStaffAcceptDigitalMenuOrders]:
		"Require staff accept digital menu orders",
	[tokens.settings.ordering.addVat]: "Add VAT",
	[tokens.settings.ordering.howVatShouldBeCharged]:
		"How VAT should be charged?",
	[tokens.settings.ordering.separatelyAsLineItem]: "Separately as line item",
	[tokens.settings.ordering.vatShowMessage]:
		"VAT will be shown to your consumers on the checkout page as a separate VAT charges",
	[tokens.settings.ordering.vatBuriedMessage]:
		"VAT will be attributed to all your items and options price, and your consumers will not see a VAT charges",
	[tokens.settings.ordering.addServiceCharge]: "Add service charge",
	[tokens.settings.ordering.addServiceChargeAd]: "Add service charge (AD)",
	[tokens.settings.ordering.howMuchForServiceCharge]:
		"How much for service charge (AD)",
	[tokens.settings.ordering.serviceFeeNote]:
		"Note that the above amount will include 5% Served fee",
	[tokens.settings.ordering.howServiceShouldCharged]:
		"How service charge should be charged?",
	[tokens.settings.ordering.buriedInItemsAndOptionsPrice]:
		"Buried in items and options price",
	[tokens.settings.ordering.buriedInItemsAndOptionsPrice]:
		"Buried in items and options price",
	[tokens.settings.ordering.serviceChargeShowMessage]:
		"Service charge will be shown to your consumers on the checkout page as a separate service charge",
	[tokens.settings.ordering.serviceChargeBuriedMessage]:
		"Service charge will be attributed to all your items and options price, and your consumers will not see a service charge",
	[tokens.settings.ordering.addServiceChargeBd]: "Add service charge (BD)",
	[tokens.settings.ordering.howMuchForServiceChargeBd]:
		"How much for service charge (BD)",
	[tokens.settings.ordering.serviceChargeBdShowMessage]:
		"Service charge (BD) will be shown to your consumers on the checkout page as a separate service charge",
	[tokens.settings.ordering.serviceChargeBdBuriedMessage]:
		"Service charge (BD) will be attributed to all your items and options price, and your consumers will not see a service charge",
	[tokens.settings.ordering.defaultServiceCharge]: "Default service charge",
	[tokens.settings.ordering.opsPageFontSize]:
		"Operation page font size (pixels)",
	[tokens.settings.ordering.opsPageFontsSizePx]: "Font size (pixels)",
	[tokens.settings.printing.printServiceStatus]: "Print service status",
	[tokens.settings.printing.printServiceStatusMessage]:
		"Print service is offline for this terminal",
	[tokens.settings.printing.printOrderChecklist]: "Print order checklist",
	[tokens.settings.printing.printTicketByItem]: "Print ticket by item",
	[tokens.settings.printing.printTicketByOption]: "Print ticket by option",
	[tokens.settings.printing.isGroupingOptionOnPrintTicket]:
		"Group option on print ticket",
	[tokens.settings.printing.isWorkTicketRemoveOrderNumber]:
		"Work ticket remove order#",
	[tokens.settings.printing.isWorkTicketRemovePrice]:
		"Work ticket remove price",
	[tokens.settings.printing.isIncludeTotalQtyInReceipt]:
		"Include Total qty in Bill / Receipt",
	[tokens.settings.printing.groupPrinterTagsOnOneTicket]:
		"Group printer tags on one ticket",
	[tokens.settings.addOns.reservationManagement]: "Reservation Management",
	[tokens.settings.addOns.customerManagement]: "Customer Management",
	[tokens.settings.addOns.kds]: "KDS",
	[tokens.settings.printing.printContentPaddingPixels]:
		"Print content padding (pixels)",
	[tokens.settings.printing.topPx]: "Top (px)",
	[tokens.settings.printing.rightPx]: "Right (px)",
	[tokens.settings.printing.bottomPx]: "Bottom (px)",
	[tokens.settings.printing.leftPx]: "Left (px)",
	[tokens.settings.printing.printFontSizesPixels]: "Print font sizes (pixels)",
	[tokens.settings.printing.ticketChecklistMessagePx]:
		"Ticket, checklist, message (px)",
	[tokens.settings.printing.billReceiptPx]: "Bill, receipt (px)",
	[tokens.settings.printing.reportsPx]: "Reports (px)",
	[tokens.settings.printing.createNewStation]: "Create new station",
	[tokens.settings.printing.createNewWorkStation]: "Create new work station",
	[tokens.settings.printing.updateWorkStation]: "Update work station",
	[tokens.settings.printing.whatShouldBeTheStationName]:
		"What should be the station name?",
	[tokens.settings.printing.selectAPrinterForThisStation]:
		"Select a printer for this station",
	[tokens.settings.printing.itemTypesOfInterest]: "Item types of interest",
	[tokens.settings.printing.printerTagsOfInterest]: "Printer tags of interest",
	[tokens.settings.printing.locationsOfInterest]: "Locations of interest",
	[tokens.settings.printing.cancel]: "Cancel",
	[tokens.settings.printing.save]: "Save",
	[tokens.settings.printing.stationName]: "Station name",
	[tokens.settings.printing.usingPrinter]: "Using printer",
	[tokens.settings.printing.manage]: "Manage",
	[tokens.settings.printing.kitchenMessage]: "Kitchen message",
	[tokens.settings.printing.ticket]: "ticket",
	[tokens.settings.printing.receipt]: "receipt",
	[tokens.settings.printing.checklist]: "checklist",
	[tokens.settings.printing.report]: "report",
	[tokens.settings.printing.cancelledOrderTicket]: "Cancelled order ticket",
	[tokens.settings.printing.delete]: "Delete",
	[tokens.settings.customs.customPrintingFields]: "Custom printing fields",
	[tokens.settings.customs.typeAndPressEnter]: "Type and press enter",
	[tokens.settings.customs.availableItemTypes]: "Available item types",
	[tokens.settings.customs.customPaymentTypes]: "Custom payment types",
	[tokens.settings.customs.shifts]: "Shifts",
	[tokens.settings.customs.reportsAvailability]: "Reports availability",
	[tokens.settings.customs.locationGroupTags]: "Location group tags",
	[tokens.settings.customs.printerTagsOfInterest]: "Printer tags of interest",
	[tokens.settings.customs.orderCancelReasons]: "Order cancel reasons",
	[tokens.settings.customs.presetMessages]: "Preset messages",
	[tokens.settings.customs.darkMode]: "Dark mode",
	[tokens.settings.customs.receiptFormat]: "Receipt format",
	[tokens.settings.customs.receiptCurrentCounter]: "Receipt current counter",
	[tokens.settings.customs.semicolonIsAReservedCharacter]:
		"Semicolon (;) is a reserved character",
	[tokens.settings.customs.currenciesConfiguration]: "Currencies configuration",
	[tokens.settings.customs.currencyCode]: "Currency code",
	[tokens.settings.customs.rateToPrimaryCurrency]: "Rate to primary currency",
	[tokens.settings.customs.primary]: "Primary",
	[tokens.settings.customs.secondary]: "Secondary",
	[tokens.settings.customs.deactivate]: "Deactivate",
	[tokens.settings.customs.addCurrency]: "Add currency",
	[tokens.settings.customs.createCurrencyConfiguration]:
		"Create currency configuration",
	[tokens.settings.customs.rateComparedToPrimaryCurrency]:
		"Rate compared to primary currency",
	[tokens.settings.customs.defaultOpsPage]: "Default ops page",
	[tokens.settings.customs.printerTags]: "Printer tags",
	[tokens.settings.userPermissions.searchUsername]: "Search username",
	[tokens.settings.userPermissions.reFetchUsers]: "Re-Fetch users",
	[tokens.settings.userPermissions.userLimitReached]: "User limit reached",
	[tokens.settings.userPermissions.resetUserPassword]: "Reset user password",
	[tokens.settings.userPermissions.resetThisUserPassword]:
		"Reset this user password",
	[tokens.settings.userPermissions.createNewUser]: "Create new user",
	[tokens.settings.userPermissions.updateNewUser]: "Update new user",
	[tokens.settings.userPermissions.editNotAllow]:
		"You are not allowed to make changes to a user with the same or higher priviledges",
	[tokens.settings.userPermissions.youAreAboutToDeleteThisUser]:
		"You are about to delete this user",
	[tokens.settings.userPermissions.firstName]: "First name",
	[tokens.settings.userPermissions.lastName]: "Last name",
	[tokens.settings.userPermissions.username]: "Username",
	[tokens.settings.userPermissions.password]: "Password",
	[tokens.settings.userPermissions.confirmPassword]: "Confirm password",
	[tokens.settings.userPermissions.fourDigitPinNumber]: "4 digit pin number",
	[tokens.settings.userPermissions.type]: "Type",
	[tokens.settings.userPermissions.ORDER_MANAGEMENT_FEATURE]:
		"Order Management Feature",
	[tokens.settings.userPermissions.VIEW_ORDER]: "View order",
	[tokens.settings.userPermissions.CREATE_ORDER]: "Create order",
	[tokens.settings.userPermissions.CANCEL_ITEM]: "Cancel item",
	[tokens.settings.userPermissions.EDIT_ORDER_BEFORE_BILL_PRINTED]:
		"Edit Order before bill printed",
	[tokens.settings.userPermissions.EDIT_ORDER_AFTER_BILL_PRINTED]:
		"Edit order after bill printed",
	[tokens.settings.userPermissions.EDIT_ORDER_BEFORE_PAYMENT]:
		"Edit order before payment",
	[tokens.settings.userPermissions.EDIT_ORDER_AFTER_PAYMENT]:
		"Edit order after payment",
	[tokens.settings.userPermissions.CANCEL_ORDER_BEFORE_BILL_PRINTED]:
		"Cancel order before bill printed",
	[tokens.settings.userPermissions.CANCEL_ORDER_AFTER_BILL_PRINTED]:
		"Cancel order after bill printed",
	[tokens.settings.userPermissions.CANCEL_ORDER_BEFORE_PAYMENT]:
		"Cancel order before payment",
	[tokens.settings.userPermissions.CANCEL_ORDER_AFTER_PAYMENT]:
		"Cancel order after payment",
	[tokens.settings.userPermissions.EDIT_LISTED_ITEM_PRICE]:
		"Edit listed item price",
	[tokens.settings.userPermissions.RECEIPT_MANAGEMENT]: "Receipt management",
	[tokens.settings.userPermissions.CANCEL_RECEIPT]: "Cancel receipt",
	[tokens.settings.userPermissions.MENU_MANAGEMENT]: "Menu management",
	[tokens.settings.userPermissions.ACCESS_MENU_MANAGEMENT]:
		"Access menu management",
	[tokens.settings.userPermissions.EDIT_MENU_MANAGEMENT]:
		"Edit menu management",
	[tokens.settings.userPermissions.TOGGLE_ITEM_AVAILABILITY]:
		"Turn on / off item",
	[tokens.settings.userPermissions.REPORTS_MANAGEMENT]: "Reports management",
	[tokens.settings.userPermissions.ACCESS_REPORTS]: "Access reports",
	[tokens.settings.userPermissions.USER_SETTINGS]: "User settings",
	[tokens.settings.userPermissions.OPEN_CASHDRAWER]: "Open cashdrawer",
	[tokens.settings.userPermissions.CHANGE_OPS_PRINTER]: "Change ops printer",
	[tokens.settings.userPermissions.EDIT_ORDER_TIMESTAMP]:
		"Edit order timestamp",
	[tokens.settings.userPermissions.EDIT_RECEIPT_TIMESTAMP]:
		"Edit receipt timestamp",
	[tokens.settings.userPermissions.AUTO_LOGOUT]: "Auto logout",
	[tokens.settings.addOns.enableCustomReceiptFormat]: "Receipt format",
	[tokens.settings.addOns.consumerAppTheme]: "Consumer app theme",
	[tokens.settings.addOns.reportsDisplayFigure]: "Reports display figure",
	[tokens.settings.addOns.reportsDisplayFigureGrossSales]: "Gross sales",
	[tokens.settings.addOns.reportsDisplayFigureGrossSalesAndTips]:
		"Gross sales + tips",
	[tokens.settings.addOns.reportsDisplayFigureGrossSalesTipsRounding]:
		"Gross sales + tips + rounding amount",
	[tokens.settings.addOns.reportsDisplayFigureGrossSalesAndRounding]:
		"Gross sales + rounding amount",
	[tokens.settings.addOns.primaryColor]: "Primary color",
	[tokens.settings.addOns.primaryTextColor]: "Primary text color",
	[tokens.settings.addOns.enableInventoryMangement]:
		"Enable inventory mangement",
	[tokens.settings.addOns.enablePurchaseManagement]:
		"Enable purchase management",
	[tokens.settings.addOns.enableCostManagement]: "Enable cost management",
	[tokens.settings.addOns.enablePaymentRounding]: "Enable payment rounding",
	[tokens.settings.addOns.allowAddItemsToPaidOrders]: "Add item to paid order",
	[tokens.settings.addOns.venueOnlyUseDigitalMenu]:
		"Venue only use digital menu",
	[tokens.settings.addOns.paywayLabel]:
		"Whether venue has PayWay integration enabled:",
	[tokens.settings.addOns.kpayLabel]:
		"Whether venue has KPay integration enabled",
	[tokens.settings.addOns.enableInternalReceipt]: "Enable internal receipt",
	[tokens.settings.addOns.enableLanguageLocalization]:
		"Enable Language Localization",
	[tokens.settings.addOns.requireHeadcountBeforePayment]:
		"Require headcount before payment",
	[tokens.settings.addOns.requireHeadcountBeforeOrdering]:
		"Require headcount before ordering",
	[tokens.settings.addOns.opsIntervalLabel]:
		"Operational Data Refectch Interval (minutes)",
	[tokens.settings.addOns.enableRoomMasterIntegration]:
		"Enable Room Master Integration",
	[tokens.settings.addOns.setUpRoomMasterPropertyId]:
		"Set up Room Master Property id",
	[tokens.settings.addOns.enableCustomReport]: "Enable custom report",
	[tokens.settings.addOns.enableDualScreenMode]: "Enable dual screen mode",
	[tokens.settings.addOns.userLimit]: "User limit",
	[tokens.settings.addOns.yes]: "Yes",
	[tokens.settings.addOns.no]: "No",
	[tokens.printservice.staff]: "Staff",
	[tokens.printservice.print]: "Print",
	[tokens.printservice.ordered]: "Ordered",
	[tokens.printservice.orders]: "Orders #",
	[tokens.printservice.qty]: "Qty",
	[tokens.printservice.item]: "Item",
	[tokens.printservice.price]: "Price",
	[tokens.printservice.subtotal]: "Subtotal",
	[tokens.printservice.vat]: "VAT",
	[tokens.printservice.serviceCharge]: "Service charge",
	[tokens.printservice.serviceChargeAd]: "Service charge (AD)",
	[tokens.printservice.serviceChargeBd]: "Service charge (BD)",
	[tokens.printservice.grandTotal]: "Grand total",
	[tokens.printservice.receipt]: "Receipt#",
	[tokens.printservice.paymentTypes]: "Payment types",
	[tokens.printservice.cashReceived]: "Cash received",
	[tokens.printservice.cashChanges]: "Cash changes",
	[tokens.printservice.received]: "Received",
	[tokens.global.bill]: "Bill",
	[tokens.global.noPermission]: "You do not have permission to view this page.",
	[tokens.global.featureDisabled]: "This feature is disabled for this venue.",
	[tokens.global.location]: "Location",
	[tokens.global.orders]: "Orders",
	[tokens.global.placed]: "Placed",
	[tokens.global.preparing]: "Preparing",
	[tokens.global.processed]: "Processed",
	[tokens.global.proceed]: "Proceed",
	[tokens.global.unpaid]: "Unpaid",
	[tokens.global.paid]: "Paid",
	[tokens.global.pay]: "Pay",
	[tokens.global.payNow]: "Pay now",
	[tokens.global.payLater]: "Pay later",
	[tokens.global.move]: "Move",
	[tokens.global.of]: "of",
	[tokens.global.not]: "Not",
	[tokens.global.all]: "All",
	[tokens.global.allowed]: "Allowed",
	[tokens.global.details]: "Details",
	[tokens.global.view]: "View",
	[tokens.global.add]: "Add",
	[tokens.global.create]: "Create",
	[tokens.global.edit]: "Edit",
	[tokens.global.update]: "Update",
	[tokens.global.save]: "Save",
	[tokens.global.yes]: "Yes",
	[tokens.global.no]: "No",
	[tokens.global.delete]: "Delete",
	[tokens.global.send]: "Send",
	[tokens.global.undo]: "Undo",
	[tokens.global.back]: "Back",
	[tokens.global.close]: "Close",
	[tokens.global.done]: "Done",
	[tokens.global.cancel]: "Cancel",
	[tokens.global.cancelled]: "Cancelled",
	[tokens.global.subtotal]: "Subtotal",
	[tokens.global.offer]: "Offer",
	[tokens.global.discount]: "Discount",
	[tokens.global.vat]: "VAT",
	[tokens.global.service]: "Service",
	[tokens.global.cardSurcharge]: "Card surcharge",
	[tokens.global.adjustment]: "Adjustment",
	[tokens.global.grandTotal]: "Grand total",
	[tokens.global.presetMessages]: "Preset messages",
	[tokens.global.logout]: "Log out",
	[tokens.global.manage]: "Manage",
	[tokens.global.copy]: "Copy",
	[tokens.global.copied]: "Copied",
	[tokens.global.addThisOption]: "Add this option",
	[tokens.global.cancelReason]: "Cancel reason",
	[tokens.global.cancelReasonIsRequired]: "Cancellation reason is required",
	[tokens.global.createAndReturnToTill]: "Create and return to till",
	[tokens.global.reset]: "Reset",
	[tokens.global.newerAppVersionAvailable]:
		"Newer version of the app is available",
	[tokens.global.reloadPage]: "Reload the page",
	[tokens.global.tax]: "Tax",
	[tokens.notifications.paywayOrderFailure.checkoutNotCompleted]:
		"{{place}} — PayWay checkout not completed ({{currency}} {{amount}}). No payment received.",
	[tokens.notifications.paywayOrderFailure.paymentFailed]:
		"{{place}} — PayWay payment failed ({{currency}} {{amount}}). No payment received.",
	[tokens.notifications.paywayOrderFailure.postbackNotReceived]:
		"{{place}} — customer PAID {{currency}} {{amount}} by PayWay but we got no confirmation. {{ending}}",
	[tokens.notifications.paywayOrderFailure.processingFailed]:
		"{{place}} — customer PAID {{currency}} {{amount}} by PayWay but processing it failed. {{ending}}",
	[tokens.notifications.paywayOrderFailure.statusUnknown]:
		"{{place}} — PayWay could not confirm a {{currency}} {{amount}} payment. Check with the customer before taking payment again.",
	[tokens.notifications.paywayOrderFailure.orderNotCreated]:
		"Order was not created.",
	[tokens.notifications.paywayOrderFailure.orderNotMarkedPaid]:
		"Order is not marked paid.",
	[tokens.notifications.paywayOrderFailure.placeWithOrder]:
		"{{location}}, order #{{index}}",
};
